import { EAccountPermissions } from 'modules/auth/context/permify/permify.interfaces';
import { useState } from 'react';
import { LegalPersonEditBillingAddressSection } from '.';
import { EditWrapper, Heading3 } from '../../../../../../app/components';
import { AddressIcon } from '../../../../../../app/components/Icons';
import { formatCep } from '../../../../../../app/helpers';
import { TRegisterBusinessDataRequest } from '../../../../context';
import {
  LegalPersonViewAddressContent,
  LegalPersonViewAddressIcon,
  LegalPersonViewBoxContainer,
  LegalPersonViewPageSection,
} from './styles';
import { useTheme } from '@mui/material';

type ILegalPersonViewBillingAddressSectionProps = {
  business: TRegisterBusinessDataRequest;
};

const LegalPersonViewBillingAddressSection = ({
  business,
}: ILegalPersonViewBillingAddressSectionProps) => {
  const { billing_address } = business;
  const [isEditOpen, setIsEditOpen] = useState(false);
  const theme = useTheme();

  return (
    <>
      <LegalPersonViewPageSection>
        <Heading3
          style={{ color: theme.palette.brand.secondary.base as string }}
        >
          Endereço de Cobrança
        </Heading3>
        <EditWrapper
          handleClick={() => setIsEditOpen(true)}
          permission={EAccountPermissions.UPDATE_PERSON_BUSINESS}
        >
          <LegalPersonViewBoxContainer>
            <LegalPersonViewAddressIcon>
              <AddressIcon
                color={theme.palette.brand.secondary.base as string}
              />
            </LegalPersonViewAddressIcon>
            <LegalPersonViewAddressContent>
              {billing_address ? (
                <>
                  <span
                    style={{
                      display: 'block',
                    }}
                  >{`${billing_address?.street_name}, ${
                    billing_address?.street_number
                  }, ${
                    billing_address?.extra_info
                      ? billing_address.extra_info
                      : ''
                  } `}</span>
                  <span
                    style={{
                      display: 'block',
                    }}
                  >{`${billing_address.district} - ${billing_address.city} - ${billing_address.state_code}`}</span>
                  <span
                    style={{
                      display: 'block',
                    }}
                  >{`${formatCep(billing_address.postal_code)}`}</span>
                </>
              ) : (
                '-'
              )}
            </LegalPersonViewAddressContent>
          </LegalPersonViewBoxContainer>
        </EditWrapper>
      </LegalPersonViewPageSection>
      <LegalPersonEditBillingAddressSection
        isOpen={isEditOpen}
        handleClose={() => setIsEditOpen(false)}
        business={business}
      />
    </>
  );
};

export default LegalPersonViewBillingAddressSection;
